import { useEffect, useState, useRef, RefObject } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import Form from '../../Form';
import {
  Wrapper,
  Title,
  ProgressWrapper,
  Progress,
  ProgressArrow,
  Desc,
  FormWrapper,
  Button,
  ButtonWrapper,
  AuthInfo,
  AuthInfoHeader,
  AuthInfoValue,
} from "./style"

const Input = () => {
  return (
    <Wrapper>
      <Title>
        memart 本登録フォーム
      </Title>
      <ProgressWrapper>
        <Progress>① 利用規約確認</Progress>
        <ProgressArrow><FaCaretRight/></ProgressArrow>
        <Progress>② 情報入力</Progress>
        <ProgressArrow><FaCaretRight/></ProgressArrow>
        <Progress active>③ 完了</Progress>
      </ProgressWrapper>
      <Desc>
        memartへの本登録が完了いたしました。
        <br/>
        以下の認証情報でmemartのマイページからログインしてください。
      </Desc>
      <AuthInfo>
        <div>
          <AuthInfoHeader>
            <div>
              ID
            </div>
          </AuthInfoHeader>
          <AuthInfoValue>
            お客様番号8桁
            <br/>
            (例: 00000000)
          </AuthInfoValue>
        </div>
        <div>
          <AuthInfoHeader>
            <div>
              パスワード
            </div>
          </AuthInfoHeader>
          <AuthInfoValue>
            お客様番号8桁末尾に
            <br/>
            mem
            <br/>
            をつなげたもの
            <br/>
            (例: 00000000mem)
          </AuthInfoValue>
        </div>
      </AuthInfo>
      <ButtonWrapper>
        <Button onClick={() => {
          window.location.href = "https://memart.jp"
        }}>
          memartトップページへ
        </Button>
      </ButtonWrapper>
      <Desc>
        以下のリンクから「節電ポイント」の参加申込が可能です。
      </Desc>
      <ButtonWrapper>
        <Button onClick={() => {
          window.location.href = "/save-energy-regist"
        }}>
          節電ポイント参加申込ページへ
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}
export default Input;
